<template>
  <v-app>
    <v-layout row justify-center>
      <v-flex class="pl-4 pr-4 mt-3 mb-4" xs12 sm11>
        <v-card>
          <v-toolbar color="grey" dark dense>
            <v-toolbar-title>Municipios</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="grey darken-2" dark class="mb-2" v-on="on">Nuevo</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field
                            v-model.trim="editedItem.nombre"
                            label="Nombre del Municipio"
                            :rules="notBlankRules"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            label="Estado"
                            value="Jalisco"
                            disabled
                            persistent-hint
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-select
                            v-model.trim="editedItem.partido_judicial_id"
                            :items="partidosJudiciales"
                            label="Partido Judicial"
                            outlined
                            dense
                        ></v-select>
                        </v-flex>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="red darken-1" dark @click.native="close">Cancelar</v-btn>
                          <v-btn v-if="editedIndex > -1" class="ma-2 white--text" color="yellow darken-2" @click.native="editMunicipio(editedItem)" :disabled="!valid" :loading="loading">Guardar</v-btn>
                          <v-btn v-else class="ma-2 white--text" color="yellow darken-2" @click.native="addMunicipio(editedItem)" :disabled="!valid" :loading="loading">Guardar</v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="listMunicipios"
            class="elevation-1"
            light
            :loading="loading"
            :items-per-page="itemsPerPage"
            hide-default-footer
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-select
                  class="mx-4 mt-8"
                  v-model="partidoFilter"
                  :items="partidosJudiciales"
                  label="Filtrar por Partido Judicial"
                  clearable
                  dense
                  @change="onFilterChange"
                />
              </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon color="orange" class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon color="red" @click="deleteMunicipio(item)">mdi-close</v-icon>
            </template>
          </v-data-table>
          <div class="text-center pt-2" v-if="pagination.total > 1">
            <v-pagination
              v-model="pagination.current_page"
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
            />
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
const Swal = require('sweetalert2');
export default {
  data() {
    return {
      pagination: {
        current_page: 1,
        total: 0,
      },
      itemsPerPage: 20,
      valid: true,
      dialog: false,
      loading: false,
      headers: [
        { text: 'Id', value: 'id', sortable: true },
        { text: 'Nombre', value: 'nombre', sortable: true },
        { text: 'Partido Judicial', value: 'partido_judicial_id', sortable: true },
        { text: 'Acciones', value: 'action', width: '15%', sortable: false }
      ],
      editedIndex: -1,
      partidoFilter: null,
      partidosJudiciales: Array.from({length: 32}, (_, i) => i + 1),
      listMunicipios: [],
      editedItem: {
        nombre: '',
        partido_judicial_id: '',
      },
      defaultItem: {
        nombre: '',
        partido_judicial_id: '',
      },
      notBlankRules: [v => !!v || 'Este campo es requerido'],
      partidoRules: [
        v => !!v || 'Este campo es requerido',
        v => /^\d{1,2}$/.test(String(v)) || 'Debe ser un número de máximo 2 dígitos',
      ],
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Municipio' : 'Editar Municipio'
    },
  },
  mounted() {
    this.getMunicipios();
  },
  methods: {
    getMunicipios() {
      this.loading = true;
      let params = '';
      if (this.partidoFilter) {
        params = '&partido_judicial_id=' + this.partidoFilter;
      }
      this.$store.dispatch("LIST_JUZGADOS", { url: "/listMunicipios?page=" + this.pagination.current_page + params }).then(response => {
        this.pagination.current_page = response.data.data.municipios.current_page;
        this.pagination.total = response.data.data.municipios.last_page;
        this.listMunicipios = response.data.data.municipios.data;
        this.loading = false;
      })
      .catch(err => {
        console.log(err);
        this.loading = false;
      });
    },
    onPageChange() {
      this.getMunicipios();
    },
    onFilterChange() {
      this.pagination.current_page = 1;
      this.getMunicipios();
    },
    editItem(item) {
      this.editedIndex = this.listMunicipios.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    addMunicipio() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("SAVE_JUZGADO", { url: "/municipio", data: this.editedItem }).then(() => {
          this.close();
          Swal.fire({ icon: 'success', title: 'Municipio creado correctamente', confirmButtonText: "Aceptar" });
          this.getMunicipios();
        })
        .catch(error => {
          this.loading = false;
          Swal.fire({ icon: 'error', title: 'Error', text: error.response && error.response.data ? error.response.data.errors || error.response.data.message : 'Error al crear', confirmButtonText: "Aceptar" });
        });
      }
    },
    editMunicipio(item) {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$store.dispatch("EDIT_JUZGADO", { url: "/municipio/" + item.id, data: item }).then(() => {
          Swal.fire({ icon: 'success', title: 'Municipio actualizado correctamente', confirmButtonText: "Aceptar" });
          this.getMunicipios();
          this.close();
        })
        .catch(error => {
          this.loading = false;
          Swal.fire({ icon: 'error', title: 'Error', text: error.response && error.response.data ? error.response.data.errors || error.response.data.message : 'Error al actualizar', confirmButtonText: "Aceptar" });
        });
      }
    },
    deleteMunicipio(item) {
      this.$swal({
        title: '¿Desea eliminar el municipio ' + item.nombre + '?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("DELETE_JUZGADO", { url: "/municipio/" + item.id }).then(() => {
            Swal.fire({ icon: 'success', title: 'Municipio eliminado correctamente', confirmButtonText: "Aceptar" });
            this.getMunicipios();
          })
          .catch(err => {
            console.log(err);
          });
        }
      });
    },
    close() {
      this.dialog = false;
      this.loading = false;
      setTimeout(() => {
        this.$refs.form.reset();
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  }
}
</script>
